<template>
  <BittsTooltip placement="top" :mount-to-body="true">
    <BittsButton
      v-bind="$attrs"
      :center-icon="icon"
      :aria-label="label"
      type="neutral"
      variant="outline"
      size="small"
      @click="toggle"
    />
    <template #title>{{ label }}</template>
  </BittsTooltip>
</template>

<script setup lang="ts">
import { BittsButton, BittsTooltip } from '@crossbeam/bitts';

import { computed } from 'vue';

import { useIRPTracking } from './useIRPTracking';
import type { IRPCtaType } from './useIRPTracking';

const { cta } = defineProps<{
  cta: IRPCtaType;
}>();

defineOptions({ inheritAttrs: false });

const isExpanded = defineModel<boolean>('isExpanded', { required: true });

const { trackIRPInteraction } = useIRPTracking();

const icon = computed<['fak', string]>(() =>
  isExpanded.value ? ['fak', 'collapse-all'] : ['fak', 'expand-all'],
);
const label = computed(() =>
  isExpanded.value ? 'Collapse all' : 'Expand all',
);

function toggle() {
  trackIRPInteraction({
    cta,
    cta_2: isExpanded.value ? 'collapse_all' : 'expand_all',
  });
  isExpanded.value = !isExpanded.value;
}
</script>
